export enum CustomHeaderAction {
  PinContent = `pin-content`,
}
